import store from 'redux/store'
import gtagManager from 'gtagManager'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

export const getGtmAttributes = () => {
    const state = store.store.getState()
    const { queryparam = {}, instructions = {} } = state
    const testData = instructions.testData || {}

    const commonData = {
        [ANALYTICS_KEYS.CLASS_STUDYING]: queryparam.class_studying,
        [ANALYTICS_KEYS.ROLL_NUMBER]: queryparam.roll_no,
        [ANALYTICS_KEYS.UUID]: queryparam.uuid,
        [ANALYTICS_KEYS.BRANCH_CODE]: queryparam.branch_code,
    }
    const otherCommonTestData = {
        [ANALYTICS_KEYS.LANGUAGE]: localStorage.getItem('i18nextLng'),
        [ANALYTICS_KEYS.DOB]: queryparam?.dob,
        [ANALYTICS_KEYS.STREAM]: queryparam?.stream,
        [ANALYTICS_KEYS.TEST_SHORT_CODE]: queryparam.test_short_code,
        [ANALYTICS_KEYS.TEST_TYPE]: queryparam?.test_type,
        [ANALYTICS_KEYS.EXAM_TYPE]: queryparam?.exam_type,
        [ANALYTICS_KEYS.GRACE_PERIOD]: queryparam?.grace_period,
        [ANALYTICS_KEYS.TEST_ID]: testData.id,
        [ANALYTICS_KEYS.TEST_NAME]: testData.titleEn,
        [ANALYTICS_KEYS.DURATION_OF_TEST]: testData.allowedDuration,
        [ANALYTICS_KEYS.DISCONNECTION_TIME]: queryparam.disconnect_time * 60,
        [ANALYTICS_KEYS.TOTAL_QUESTIONS]: testData.totalQuestion,
        [ANALYTICS_KEYS.MAX_MARKS]: testData.maxMarks,
    }
    return { ...commonData, ...otherCommonTestData }
}

export const gtmTrackEvent = (eventName, payload = {}) => {
    const isPreview =
        sessionStorage.getItem('tp_preview_token') &&
        sessionStorage.getItem('test_id')
            ? true
            : false
    if (!eventName || isPreview) return
    if (
        window.location.protocol === 'https:' ||
        window.location.host === 'localhost:3000'
    ) {
        gtagManager({ eventName, eventData: { ...getGtmAttributes(), ...payload } })
    }
}
